import { isArray } from 'lodash-es';

import { AVAILABLE_CHARGES_ISSUE_TYPES, ChargesIssueType } from './approveChargesTabs';

export const ISSUE_TYPES_STORAGE_KEY = 'approve_charges_issue_types';

const isAvailableIssueType = (value: unknown): value is ChargesIssueType =>
  AVAILABLE_CHARGES_ISSUE_TYPES.some((type) => type === value);

export function readStoredIssueTypes(): ChargesIssueType[] {
  try {
    const stored: unknown = JSON.parse(
      localStorage.getItem(ISSUE_TYPES_STORAGE_KEY) ?? 'null',
    );

    const storedIssueTypes = isArray(stored) ? stored.filter(isAvailableIssueType) : [];

    return storedIssueTypes.length > 0 ? storedIssueTypes : AVAILABLE_CHARGES_ISSUE_TYPES;
  } catch {
    // Storage can throw in private mode, or hold a value from another build.
    return AVAILABLE_CHARGES_ISSUE_TYPES;
  }
}

export function writeStoredIssueTypes(issueTypes: ChargesIssueType[]) {
  try {
    localStorage.setItem(ISSUE_TYPES_STORAGE_KEY, JSON.stringify(issueTypes));
  } catch {
    // Not remembered, but the ticks still drive this session
  }
}
